<template>
  <el-pagination
    @size-change="sizeChangeHandle"
    @current-change="currentChangeHandle"
    :current-page="page.pageIndex"
    :page-sizes="[10, 20, 50, 100]"
    :page-size="page.pageSize"
    :total="total"
    layout="total, sizes, prev, pager, next, jumper">
  </el-pagination>
</template>
<script>
export default {
  props: {
    total: Number,
    page: {
      type: Object,
      default: function () {
        return {
          pageIndex: 1,
          pageSize: 10,
        }
      }
    }
  },
  activated() {
    this.page.pageIndex = 1;
  },
  methods: {
    sizeChangeHandle(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.$emit("pageChange", this.page);
    },
    currentChangeHandle(val) {
      this.page.pageIndex = val;
      this.$emit("pageChange", this.page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/index.vue